import React, { useEffect, useState } from "react";
import {
  Button,
  ControlLabel,
  FormControl,
  FormGroup,
  Grid,
  Modal,
} from "react-bootstrap";
import LoadingSpinner from "views/Components/loadingSpinner";
import ProfileAvatar from "./profileAvatar/ProfileAvatar";
import PackageDetails from "./packageDetails/PackageDetails";
import ActivityPanel from "./activityPanel/ActivityPanel";
import AssignmentHistoryPanel from "./assignmentHistoryPanel/AssignmentHistoryPanel";
import Consultations from "./consultations/Consultations";
import Claims from "./claims/Claims";
import RecentOrders from "./recentOrders/RecentOrders";
import Finance from "./finance/Finance";
import {
  addressText,
  displayBalance,
  displayMoney,
} from "./CallLeadDetails.utils";
import { minimumFollowUpDateTime } from "../callWorkspace.utils";
import "../callWorkspace.css";

const CallLeadDetails = (props) => {
  const [activeTab, setActiveTab] = useState("medicine");
  const [addressesOpen, setAddressesOpen] = useState(false);
  const [outcomeOpen, setOutcomeOpen] = useState(false);
  const invalidFollowUp =
    props.form &&
    props.form.outcome === "follow_up" &&
    (!props.form.next_follow_up_at ||
      new Date(props.form.next_follow_up_at).getTime() <= Date.now());

  if (props.loading)
    return (
      <main className="cw-page">
        <Grid fluid>
          <div className="cw-panel cw-detail-loading">
            <LoadingSpinner />
          </div>
        </Grid>
      </main>
    );
  if (!props.details || !props.details.lead)
    return (
      <main className="cw-page">
        <Grid fluid>
          <button type="button" className="cw-back-link" onClick={props.onBack}>
            ← Back to My Calls
          </button>
          <div className="cw-alert cw-alert-error" role="alert">
            {props.error || "Lead details could not be loaded."}
          </div>
        </Grid>
      </main>
    );

  const task = props.details.task;
  const lead = props.details.lead || (task && task.lead) || {};
  const activities = props.details.activities || { data: [] };
  const packages = lead.lead_catalogue_package || [];
  const addresses = (lead.address || []).filter(
    (address) =>
      address.is_active === true ||
      address.is_active === 1 ||
      address.is_active === "1",
  );
  const isBasicUser = Number(lead.organization_id) === 0;

  const openOutcome = () => {
    props.onResetOutcome();
    setOutcomeOpen(true);
  };
  const submitOutcome = (event) =>
    props.onSaveOutcome(event).then((saved) => {
      if (saved) setOutcomeOpen(false);
    });
  const selectTab = (key) => {
    setActiveTab(key);
    props.onTabSelect(key);
  };

  const getPrefferedLanguage = (language) => {
    switch (language) {
      case "en":
        return "English";
      case "si":
        return "Sinhala";
      case "ta":
        return "Tamil";
      case "ru":
        return "Russian";
      case "ar":
        return "Arabic";
      case "zh":
        return "Chinese";
      case "hi":
        return "Hindi";
      default:
        return "English";
    }
  };

  return (
    <main className="cw-page">
      <Grid fluid>
        {props.error || props.success ? (
          <div
            className={
              props.error
                ? "cw-alert cw-alert-error"
                : "cw-alert cw-alert-success"
            }
            role="alert"
          >
            <span>{props.error || props.success}</span>
            <button
              type="button"
              aria-label="Dismiss message"
              onClick={props.onDismissMessage}
            >
              ×
            </button>
          </div>
        ) : null}
        <div className="cw-lead-top-grid">
          <div className="cw-lead-top-main">
            <section
              className="cw-panel cw-profile-card"
              aria-labelledby="customer-name"
            >
              <div className="cw-profile-top">
                <div className="cw-profile-summary">
                  <ProfileAvatar
                    name={lead.name}
                    imageUrl={lead.profile_picture_url}
                  />
                  <div className="cw-profile-content">
                    <div className="cw-profile-heading">
                      <small className="cw-profile-lead-id">#{lead.id}</small>
                      <h1 id="customer-name">
                        <span>{`${lead.name} (${lead.mobile_no})`}</span>
                      </h1>
                      <p>{`Language: ${getPrefferedLanguage(lead.preferred_language)}`}</p>
                    </div>
                    {/* <dl className="cw-profile-details">
                      <div>
                        <dt>Call attempts</dt>
                <dd>{(task && task.call_attempts) || 0}</dd>
                      </div>
                      <div>
                        <dt>WhatsApp attempts</dt>
                <dd>{(task && task.whatsapp_attempts) || 0}</dd>
                      </div>
                    </dl> */}
                    <Button
                      className="cw-address-button"
                      onClick={() => setAddressesOpen(true)}
                    >
                      <i className="fa fa-map-marker" aria-hidden="true" /> Show
                      addresses ({addresses.length})
                    </Button>
                  </div>
                </div>
                <div className="cw-profile-side">
                  <div className="cw-balance-grid">
                    {props.details.ipd_claim_balance.available
                      .remainingCredit !== 0 && (
                      <div className="cw-balance-card cw-balance-ipd">
                        <span className="cw-balance-label">
                          <i className="fa fa-hospital-o" aria-hidden="true" />
                          IPD claim balance
                        </span>
                        <strong>
                          {displayBalance(props.details.ipd_claim_balance)}
                        </strong>
                      </div>
                    )}
                    {props.details.opd_claim_balance.available
                      .remainingCredit !== 0 && (
                      <div className="cw-balance-card cw-balance-opd">
                        <span className="cw-balance-label">
                          <i className="fa fa-stethoscope" aria-hidden="true" />
                          OPD Claim balance
                        </span>
                        <strong>
                          {displayBalance(props.details.opd_claim_balance)}
                        </strong>
                      </div>
                    )}
                    {props.details.wallet_balance.available.remainingCredit !==
                      0 && (
                      <div className="cw-balance-card cw-balance-wallet">
                        <span className="cw-balance-label">
                          <i className="fa fa-credit-card" aria-hidden="true" />
                          Flash Credits
                        </span>
                        <strong>
                          {displayBalance(props.details.wallet_balance)}
                        </strong>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {packages.length ? (
                <>
                  <div className="cw-profile-divider" />
                  <div className="cw-profile-packages">
                    <h2>Packages and discounts</h2>
                    <ul className="cw-plain-list">
                      {packages.map((item) => (
                        <PackageDetails
                          key={item.id}
                          item={item}
                          isBasicUser={isBasicUser}
                        />
                      ))}
                    </ul>
                  </div>
                </>
              ) : null}
            </section>
            <section className="cw-panel cw-history-panel">
              <div
                className="cw-history-tabs"
                role="tablist"
                aria-label="Customer history"
              >
                <button
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "medicine"}
                  className={
                    activeTab === "medicine"
                      ? "cw-history-tab is-active"
                      : "cw-history-tab"
                  }
                  onClick={() => selectTab("medicine")}
                >
                  <i className="fa fa-medkit" aria-hidden="true" />
                  Medicine Orders
                </button>
                <button
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "lab"}
                  className={
                    activeTab === "lab"
                      ? "cw-history-tab is-active"
                      : "cw-history-tab"
                  }
                  onClick={() => selectTab("lab")}
                >
                  <i className="fa fa-flask" aria-hidden="true" />
                  Lab Orders
                </button>
                <button
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "consultations"}
                  className={
                    activeTab === "consultations"
                      ? "cw-history-tab is-active"
                      : "cw-history-tab"
                  }
                  onClick={() => selectTab("consultations")}
                >
                  <i className="fa fa-user-md" aria-hidden="true" />
                  Consultations
                </button>
                <button
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "finance"}
                  className={
                    activeTab === "finance"
                      ? "cw-history-tab is-active"
                      : "cw-history-tab"
                  }
                  onClick={() => selectTab("finance")}
                >
                  <i className="fa fa-credit-card" aria-hidden="true" />
                  Finance
                </button>
                <button
                  type="button"
                  role="tab"
                  aria-selected={activeTab === "claims"}
                  className={
                    activeTab === "claims"
                      ? "cw-history-tab is-active"
                      : "cw-history-tab"
                  }
                  onClick={() => selectTab("claims")}
                >
                  <i className="fa fa-file-text-o" aria-hidden="true" />
                  Claims
                </button>
              </div>
              <div className="cw-history-content" role="tabpanel">
                {activeTab === "medicine" ? (
                  <RecentOrders
                    resource={props.medicineOrders}
                    formatDate={props.formatDate}
                    leadId={lead.id}
                    leadName={lead.name}
                    type="medicine"
                  />
                ) : null}
                {activeTab === "lab" ? (
                  <RecentOrders
                    resource={props.labOrders}
                    formatDate={props.formatDate}
                    leadId={lead.id}
                    leadName={lead.name}
                    type="lab"
                  />
                ) : null}
                {activeTab === "consultations" ? (
                  <Consultations
                    resource={props.consultations}
                    formatDate={props.formatDate}
                    onPage={props.onConsultationsPage}
                  />
                ) : null}
                {activeTab === "finance" ? (
                  <Finance finance={props.finance} />
                ) : null}
                {activeTab === "claims" ? (
                  <Claims
                    claims={props.claims}
                    transactions={props.claimTransactions}
                    policies={props.policies}
                    packages={packages}
                    formatDate={props.formatDate}
                    onClaimsPage={props.onClaimsPage}
                    onTransactionsPage={props.onClaimTransactionsPage}
                  />
                ) : null}
              </div>
            </section>
          </div>
          <aside className="cw-lead-top-sidebar" aria-label="Lead workflow">
            {task && !props.readOnly ? (
              <div className="cw-profile-actions cw-sidebar-actions">
                <div aria-label="Lead actions" className="cw-action-row">
                  <Button
                    className="cw-action-button cw-action-call"
                    aria-label="Call lead"
                    title="Call lead"
                    disabled={!!props.acting || !lead.mobile_no}
                    onClick={() => props.onAction("call")}
                  >
                    <i className="fa fa-phone" aria-hidden="true" />{" "}
                    <span className="cw-action-label">Call</span>
                  </Button>
                  <Button
                    className="cw-action-button cw-action-whatsapp"
                    aria-label="Contact lead on WhatsApp"
                    title="Contact lead on WhatsApp"
                    disabled={!!props.acting || !lead.mobile_no}
                    onClick={() => props.onAction("whatsapp")}
                  >
                    <i className="fa fa-whatsapp" aria-hidden="true" />{" "}
                    <span className="cw-action-label">WhatsApp</span>
                  </Button>
                  <Button
                    className="cw-action-button cw-action-order"
                    aria-label="Create order"
                    title="Create order"
                    disabled={!!props.acting}
                    onClick={() => props.onAction("create_order")}
                  >
                    <i className="fa fa-shopping-cart" aria-hidden="true" />{" "}
                    <span className="cw-action-label">Create order</span>
                  </Button>
                </div>
              </div>
            ) : null}
            <AssignmentHistoryPanel
              history={props.assignmentHistory}
              formatDate={props.formatDate}
              onRetry={props.onRetryAssignmentHistory}
            />
            <ActivityPanel
              activities={activities}
              formatDate={props.formatDate}
              onPage={props.onActivitiesPage}
            />
          </aside>
        </div>
        <Modal
          show={addressesOpen}
          onHide={() => setAddressesOpen(false)}
          aria-labelledby="addresses-modal-title"
        >
          <Modal.Header closeButton>
            <Modal.Title id="addresses-modal-title">
              Customer addresses
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {addresses.length ? (
              <ol className="cw-address-list">
                {addresses.map((address, index) => (
                  <li key={address.id || index}>
                    <i className="fa fa-map-marker" aria-hidden="true" />
                    <span>{addressText(address)}</span>
                  </li>
                ))}
              </ol>
            ) : (
              <p className="cw-muted">No addresses available.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setAddressesOpen(false)}>Close</Button>
          </Modal.Footer>
        </Modal>
        {task && !props.readOnly ? (
          <Modal
            show={outcomeOpen}
            onHide={() => {
              if (!props.saving) setOutcomeOpen(false);
            }}
            backdrop={props.saving ? "static" : true}
            aria-labelledby="outcome-modal-title"
          >
            <form onSubmit={submitOutcome} noValidate>
              <Modal.Header closeButton={!props.saving}>
                <Modal.Title id="outcome-modal-title">
                  Update outcome
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <FormGroup>
                  <ControlLabel>Status</ControlLabel>
                  <FormControl
                    componentClass="select"
                    name="outcome"
                    value={props.form.outcome}
                    onChange={props.onFormChange}
                  >
                    {Object.keys(props.outcomes).map((key) => (
                      <option key={key} value={key}>
                        {props.outcomes[key]}
                      </option>
                    ))}
                  </FormControl>
                </FormGroup>
                {props.form.outcome === "follow_up" ? (
                  <FormGroup>
                    <ControlLabel>Next follow-up</ControlLabel>
                    <FormControl
                      type="datetime-local"
                      name="next_follow_up_at"
                      value={props.form.next_follow_up_at}
                      min={minimumFollowUpDateTime()}
                      onChange={props.onFormChange}
                    />
                    {props.form.next_follow_up_at && invalidFollowUp ? (
                      <span className="help-block">
                        Select a future date and time.
                      </span>
                    ) : null}
                  </FormGroup>
                ) : null}
                <FormGroup>
                  <ControlLabel>Remarks</ControlLabel>
                  <FormControl
                    className="cw-textarea"
                    componentClass="textarea"
                    name="remarks"
                    value={props.form.remarks}
                    onChange={props.onFormChange}
                    maxLength={5000}
                  />
                </FormGroup>
                {props.error ? (
                  <div className="cw-tab-error" role="alert">
                    {props.error}
                  </div>
                ) : null}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  disabled={props.saving}
                  onClick={() => setOutcomeOpen(false)}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  bsStyle="primary"
                  disabled={props.saving || invalidFollowUp}
                >
                  {props.saving ? "Saving…" : "Save outcome"}
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        ) : null}
      </Grid>
    </main>
  );
};

export default CallLeadDetails;
